import React, { useState } from "react";
import { Row, Col, CustomInput, Label, FormGroup, Collapse } from "reactstrap";

export const CollapsePlusMinus = (props) => {
  const [isOpen0, setIsOpen0] = useState(props.opened);
  const toggle0 = () => setIsOpen0(!isOpen0);

  return (
    <div style={{ margin: 0, padding: 0 }}>
      <div
        onClick={toggle0}
        style={{
          marginTop: "25px",
          marginBottom: "15px",
          cursor: "pointer",
          width: "300px",
        }}
      >
        <h6>
          {props.title}
          {!isOpen0 ? (
            <i
              className="fa fa-plus"
              style={{ marginLeft: 5, color: "#3f51b5" }}
            ></i>
          ) : (
            <i
              className="fa fa-minus"
              style={{ marginLeft: 5, color: "#3f51b5" }}
            ></i>
          )}
        </h6>
      </div>
      <Collapse
        isOpen={isOpen0}
        style={{ marginBottom: 40, marginTop: "-5px" }}
      >
        {props.children}
      </Collapse>
    </div>
  );
};

export default CollapsePlusMinus;
